import React from 'react';


export class InToolbox extends React.Component<{children:any}>{
    render(){
        return this.props.children || null;
    }
}